import { ThemeColors } from '~/themes/colors'

export interface BlockedNumbersColors {
  WrapperBackgroundColor: ThemeColors
  BorderColor: ThemeColors
  NumberBackgroundColor: ThemeColors
}

export const blockedNumbersColors: BlockedNumbersColors = {
  WrapperBackgroundColor: {
    default: 'gray.200',
  },
  BorderColor: {
    default: 'gray.400',
  },
  NumberBackgroundColor: {
    default: 'gray.100',
  },
}
